/* tslint:disable */
/* eslint-disable */
/**
 *
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface Status
 */
export interface Status {
  /**
   *
   * @type {boolean}
   * @memberof Status
   */
  authenticated: boolean;
  /**
   *
   * @type {string}
   * @memberof Status
   */
  username?: string;
  /**
   *
   * @type {string}
   * @memberof Status
   */
  maptilerApiKey: string;
  /**
   *
   * @type {string}
   * @memberof Status
   */
  sendLoginLink?: string;
  /**
   *
   * @type {boolean}
   * @memberof Status
   */
  hasWriteAccess: boolean;
  /**
   *
   * @type {boolean}
   * @memberof Status
   */
  hasAdminAccess: boolean;
  /**
   * Max size of the selected area, in square kilometers
   * @type {number}
   * @memberof Status
   */
  maxSquareKilometers: number;
}

/**
 * Check if a given object implements the Status interface.
 */
export function instanceOfStatus(value: object): value is Status {
  if (!("authenticated" in value) || value["authenticated"] === undefined) return false;
  if (!("maptilerApiKey" in value) || value["maptilerApiKey"] === undefined) return false;
  if (!("hasWriteAccess" in value) || value["hasWriteAccess"] === undefined) return false;
  if (!("hasAdminAccess" in value) || value["hasAdminAccess"] === undefined) return false;
  if (!("maxSquareKilometers" in value) || value["maxSquareKilometers"] === undefined) return false;
  return true;
}

export function StatusFromJSON(json: any): Status {
  return StatusFromJSONTyped(json, false);
}

export function StatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): Status {
  if (json == null) {
    return json;
  }
  return {
    authenticated: json["authenticated"],
    username: json["username"] == null ? undefined : json["username"],
    maptilerApiKey: json["maptiler_api_key"],
    sendLoginLink: json["send_login_link"] == null ? undefined : json["send_login_link"],
    hasWriteAccess: json["has_write_access"],
    hasAdminAccess: json["has_admin_access"],
    maxSquareKilometers: json["max_square_kilometers"],
  };
}

export function StatusToJSON(json: any): Status {
  return StatusToJSONTyped(json, false);
}

export function StatusToJSONTyped(
  value?: Status | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    authenticated: value["authenticated"],
    username: value["username"],
    maptiler_api_key: value["maptilerApiKey"],
    send_login_link: value["sendLoginLink"],
    has_write_access: value["hasWriteAccess"],
    has_admin_access: value["hasAdminAccess"],
    max_square_kilometers: value["maxSquareKilometers"],
  };
}
